import React, { useState } from 'react';
import { useAppStore } from '@/store';
import { selectCalendarData } from '@/store/selectors';
import { CalendarMonth } from './CalendarMonth';
import { Button } from '../shared';

export interface CalendarGridProps {
  courseId: string;
}

export function CalendarGrid({ courseId }: CalendarGridProps): React.ReactElement {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth());

  const calendarData = useAppStore((s) => selectCalendarData(s, courseId, year, month));

  const monthName = new Date(year, month).toLocaleString('en-US', { month: 'long', year: 'numeric' });

  const goToPrev = () => {
    if (month === 0) { setYear(year - 1); setMonth(11); }
    else { setMonth(month - 1); }
  };

  const goToNext = () => {
    if (month === 11) { setYear(year + 1); setMonth(0); }
    else { setMonth(month + 1); }
  };

  return (
    <div className="calendar-grid">
      <div className="calendar-grid__nav">
        <Button variant="ghost" size="sm" onClick={goToPrev} aria-label="Previous month">
          &#8592;
        </Button>
        <h3 className="calendar-grid__month">{monthName}</h3>
        <Button variant="ghost" size="sm" onClick={goToNext} aria-label="Next month">
          &#8594;
        </Button>
      </div>
      <CalendarMonth days={calendarData} />
    </div>
  );
}
